import React, {Component} from 'react';
import {$} from '../ext-refs';
import {FieldWrapper} from "../form-validator";
import PropTypes from 'prop-types';
import classNames from "classnames";

/**
 * React wrapper for jQuery selectize.
 * @see https://selectize.github.io/selectize.js/
 */
class Selectize extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const {name, setValue, postProcess} = this.props,
            value = e.target.value;
        setValue(name, value, postProcess);
    }

    componentDidMount() {
        //console.log('Selectize mounting...');
        const $s = $(this.node);
        $s.selectize(this.props.selectizeOptions);
        $s.on('change', this.onChange);
    }

    componentWillUnmount() {
        //console.log('Selectize unmounting...');
        const $s = $(this.node);
        $s[0].selectize.destroy();
    }

    /**
     * If value changed, update the value in the selectize plugin
     * @param prevProps
     */
    componentDidUpdate(prevProps) {
        const $s = $(this.node);
        const selectize = $s[0].selectize;
        //console.log('selectize: componentDidUpdate? "' + this.props.value + '" !== "' + prevProps.value + '"');
        if (this.props.value !== prevProps.value) {
            selectize.setValue(this.props.value);
        }
    }

    render() {
        const {
                name, description, selectList,
                value, className,
                // Remove this from rest, so we don't send them to select tag
                setValue, postProcess, validationState, selectizeOptions, validations,
                ...rest
            } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        return (
            <div className={className ? className : "md-form form-group"}>
                <select key={`${name}-selectize`}
                    name={name}
                    className={classNames("form-control", {'is-invalid': hasError})}
                    value={value || ''}
                    onChange={this.onChange}
                    ref={node => {
                        //console.log('Selectize setting node');
                        this.node = node;
                    }}
                    {...rest}
                >
                    {this.props.children}
                    {selectList.map(item => (
                        <option key={item.code} value={item.code}>{item.description}</option>
                    ))}
                </select>
                {description &&
                (<label htmlFor={name} className="bootstrap-label active">
                    {description}
                </label>)
                }
                {
                    hasError && messages.map(
                        item => (
                            <div key={item} className="invalid-feedback">
                                {item}
                            </div>
                        ))
                }
            </div>
        );
    }
}

Selectize.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    postProcess: PropTypes.func,
    selectList: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
    }))
};

export default FieldWrapper(Selectize);
